import { JSX } from 'react';
import Container from '@ui/container/container';
import OptionalComponent from '@ui/optional-component/optional-component';
import Text from '@ui/text/text/text';
// commenting out tooltip for now as it no longer appears in Figma
// import { ICONS } from '@ui/icons/types';
// import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
// import Icon from '@ui/icons/icon';
import styles from './stats-card.module.css';
import { STATS_CARD_BACKGROUND_COLOR } from '../helpers/constants';

type TStatsCardProps = {
  title: string;
  tooltip: string;
  Icon: JSX.Element;
  /** set value to -1 to render `--` */
  value: number | string; // may be string for cases like video "1h 30m"
  subvalue?: string | null;
  loading?: boolean;
};

// commenting out tooltip for now as it no longer appears in Figma
const StatsCard = ({ title, /*tooltip,*/ Icon: LabelIcon, value, loading, subvalue }: TStatsCardProps) => {
  const valueDisplay = () => {
    if (loading) {
      return <>&nbsp;</>;
    }

    if (typeof value === 'string') {
      return <>{value}</>;
    }

    if (typeof value === 'number') {
      return <>{value < 0 ? <span style={{ color: 'var(--gray-700)' }}>{'-'}</span> : value.toLocaleString()}</>;
    }

    return <span style={{ color: 'var(--gray-700)' }}>{'-'}</span>;
  };

  return (
    <Container
      className={subvalue ? 'flex-2' : 'flex-1'}
      background={STATS_CARD_BACKGROUND_COLOR}
      padding="16px 16px 12px 16px"
      borderRadius="12px"
      height="84px"
      data-component="StatsCard"
    >
      <Container className="flex fd-row jc-flex-start ai-center gap-6" margin="0 0 4px 0">
        <Text color="var(--gray-300)" className="C1">
          {title}
        </Text>
        {/* 
        // commenting out tooltip for now as it no longer appears in Figma
        // leaving in case we need to re-enable it later

        <TooltipPortal
          animationType="slide-up"
          keepOpenOnContentHover={false}
          childrenWrapperClass="flex fd-row jc-center ai-center"
          disabled={!tooltip.length}
          tooltipContent={
            <Text maxWidth="250px" className="C1">
              {tooltip}
            </Text>
          }
        >
          <Icon name={ICONS.INFO_CIRCLE} size={10} color="var(--gray-300)" />
        </TooltipPortal> 
        */}
      </Container>

      <Container className="flex fd-row jc-flex-start ai-center">
        <Container height="32px" width="16px" margin="0 6px 0 0" className="flex fd-row jc-center ai-center">
          {LabelIcon}
        </Container>
        <Text
          skeletonLoader={loading}
          skeletonLoaderBackground={{ start: 'transparent', end: 'var(--gray-800)' }}
          tag="h4"
          className="H4"
          width={'100%'}
          color={Number(value) < 0 ? 'var(--gray-400)' : undefined}
        >
          {valueDisplay()}
          <OptionalComponent display={value !== undefined && !!subvalue}>
            <span className={styles.subvalue}>{' ' + subvalue}</span>
          </OptionalComponent>
        </Text>
      </Container>
    </Container>
  );
};

export default StatsCard;
